import React from 'react';

const Eclipse = ()=> {
    return (
        <React.Fragment>
            <div className="eclipse"></div>
            <div className="border_T"></div>
            <div className="border_L"></div>
        </React.Fragment>
    )
}

export default Eclipse;